import React from 'react';
import EnquiryForm from './EnquiryForm';

export default function Contact() {
  return (
    <section className="bg-accent text-white">
      <main className="section-container py-16">
        <div className="mx-auto max-w-3xl space-y-6">
          <EnquiryForm
            theme="dark"
            title="Contact"
            description="Fill out the form below and submit. We will get back to you as soon as possible."
            submitButtonText="Submit"
            onSubmit={(formData) => console.log('Form submitted:', formData)}
          />
        </div>
      </main>
    </section>
  );
}
